import { render, staticRenderFns } from "./ModalResidentialStatusNew.vue?vue&type=template&id=09e01b3c&"
import script from "./ModalResidentialStatusNew.vue?vue&type=script&lang=js&"
export * from "./ModalResidentialStatusNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports